<app-container class="flex flex-col" ngClass.xs="xs"
               [noPadding]="handsetService.isMobile"
               [maxWidth]="handsetService.isNotMobile ? '552px' : '100%'">
  <app-loading [loading]="loading" [loadingError]="loadingError"></app-loading>
  <mat-card class="container" *ngIf="!loading && !loadingError">
    <mat-card-header fxLayout="column" fxLayoutAlign="start stretch">
      <mat-card-title fxLayout="column" style="max-width: 100%">
        <div fxLayout="row" fxLayoutAlign="start"  class="text-xl" >
          <div class="biller-name"

               [routerLink]="['/liabilities/all']"
               [state]="{ query: liability?.billerName }">
            <h1>{{ liability?.billerName }}</h1>
          </div>
          <div fxLayout="row" class="justify-between">
            <div class="amount"
                 *ngIf="!amountLoading"
                 fxLayoutAlign="start center">
              <h1 class="amount" *ngIf="liability.amount !== null; else noAmount">
                {{ liability?.amount | number: '1.2-2':'pl' }} zł
              </h1>
              <ng-template #noAmount>
                <span>Brak kwoty</span>
              </ng-template>
            </div>

            <div class="amount-loader" *ngIf="amountLoading">
              <mat-spinner [diameter]="20" [strokeWidth]="5"></mat-spinner>
            </div>
            <div class="flex self-center">
              <app-expandable-menu-vertical [liability]="liability"
                                            [startedPaymentId]="startedPayment?.id !== null ? startedPayment?.id : ''">
              </app-expandable-menu-vertical>
            </div>

          </div>

        </div>
      </mat-card-title>
    </mat-card-header>

    <mat-card-content>
      <div fxLayout="column" fxLayoutAlign="start stretch" fxLayoutGap="20px" class="details">
        <div fxFlex="row" fxLayoutAlign="start center" >
          <div class="text-me">Status:</div>
          <div>
            <app-liability-status
              [status]="liability.newStatus"
              [verified]="liability.verified"
              [archiveStatus]="liability.customerBillerArchiveStatus"
              [inCart]="liability.inCart"
              [delegationData]="liability.delegationData"
              [payId]="liability.uncompletedPaymentId"
              [id]="liability.id"
              [paidBy]="liability.paidBy"
              [showReclassified]="liability?.wasReclassified"
            ></app-liability-status>
            <span fxFlex></span>
          </div>
        </div>

        <div fxFlex="row" fxLayoutAlign="start center" >
          <div class="text-me">Etykiety:</div>
          <div class="flex flex-row items-center">
            <div *ngIf="liability.tags.length > 0; else noTags" class="tags-container">
              <div
                *ngFor="let tag of liability.tags"
                ngClass.xs="xs"
                class="tag cursor-pointer"
                [routerLink]="['/liabilities/all']"
                [queryParams]="{ tag: tag.id }"
              >
                {{ tag.name }}
              </div>
              <app-icon class="editable" name="add" size="16" color="rgba(0,0,0,.47)"
                        (click)="addTagClick()"></app-icon>
            </div>
            <ng-template #noTags>
              <div (click)="addTagClick()" class="cursor-pointer flex">
                <span class="mr-4">Dodaj etykietę</span>
                <app-icon name="launch" size="16" class="icon"></app-icon>
              </div>
            </ng-template>
          </div>
        </div>

        <div fxFlex="row" fxLayoutAlign="start center" >
          <div class="text-me">Źródło:</div>
          <div class="source-description">
            <div
              fxLayout="row"
              fxLayoutAlign="start center"

              *ngIf="liability.source !== LiabilitySource.TOP_UP; else topUpLiability">
              <span
                [innerHTML]="additionalStatusDescription || liabilitySourceMap[liability.source]?.description">
              </span>
            </div>
            <ng-template #topUpLiability>
              <div class="flex items-center position-relative">
                <app-topup-icon [sizeDollar]="10" [sizeSmartphone]="18"></app-topup-icon>
                <span
                  [innerHTML]="additionalStatusDescription || liabilitySourceMap[liability.source]?.description"
                ></span>
              </div>
            </ng-template>
          </div>
        </div>

        <div
          fxFlex="row"
          fxLayoutAlign="start start"

          *ngIf="liability.source !== LiabilitySource.TOP_UP; else liabilityBiller"
        >
          <div class="text-me">Dostawca:</div>
          <div
            class=" biller-name"
            fxLayout="row"
            fxLayoutAlign="start center"
            [routerLink]="['/liabilities/all']"
            [state]="{ query: liability.billerName }"
          >
            <span class="ellipsis" style="white-space: normal; max-width: 100%;" fxFlex="nogrow">{{ liability?.billerName }}</span>
            <span *ngIf="liability.customerBillerArchiveStatus === archiveStatus.ARCHIVED">&nbsp;(zarchiwizowany)</span>
          </div>
        </div>

        <ng-template #liabilityBiller>
          <div fxFlex="row" fxLayoutAlign="start start" >
            <div class="text-me">Operator:</div>
            <div>{{ liability.billerName }} ({{ liabilityOperator }})</div>
          </div>
        </ng-template>

        <div *ngIf="liability.subAccount" fxFlex="row" fxLayoutAlign="start start" >
          <div class="text-me">Informacje dodatkowe:</div>
          <div
            class="subaccount-name"
            [routerLink]="['/liabilities/all']"
            [state]="{ query: liability.subAccount.name }"
          >
            {{ liability.subAccount.name }}
          </div>
        </div>

        <div
          *ngIf="liability.automaticPayment?.automaticPaymentScheduledDate"
          fxFlex="row"
          fxLayoutAlign="start start"

        >
          <div class="text-me">Autopłatność:</div>
          <div>{{ liability.automaticPayment.automaticPaymentScheduledDate | date: defaultPattern }}</div>
        </div>

        <div fxFlex="row" fxLayoutAlign="start start" >
          <div class="text-me">Termin płatności:</div>
          <div>
            {{ liability?.paymentDue | date: defaultPattern }}
          </div>
        </div>

        <div fxFlex="row" fxLayoutAlign="start start" >
          <div class="text-me">Łączna kwota należności:</div>

          <div
            class="amount"
            [class.editable]="liability.amountEditable"
            *ngIf="!amountLoading"
            fxFlex="none"
            fxLayout="row"
            fxLayoutAlign="start center"

            (click)="liability.amountEditable && editAmount()"
          >
            <div *ngIf="liability.amount !== null; else noAmount">
              {{ liability?.amount | number: '1.2-2':'pl' }} zł
            </div>

            <ng-template #noAmount>
              <span>Brak</span>
            </ng-template>
          </div>
        </div>

        <div
          *ngIf="liability.amountToPay !== 0 && liability.amountToPay !== null"
          fxFlex="row"
          fxLayoutAlign="start start"

        >
          <div class="text-me">Pozostało do opłacenia:</div>
          <div>{{ liability?.amountToPay | number: '1.2-2':'pl' }} zł</div>
        </div>
        <div *ngIf="liability.payments?.length" fxFlex="row" fxLayoutAlign="start start" >
          <div class="text-me">Płatnoś{{ liability.payments.length > 1 ? 'ci' : 'ć' }}:</div>
          <div fxLayout="column">
            <div
              *ngFor="let payment of liability.payments"
              fxFlex="none"
              fxLayout="row"
              fxLayoutAlign="start center"

            >
              <div>
                {{ payment.paidAt | date: defaultPatternWithTime }} na kwotę
                {{ payment.amount | number: '1.2-2':'pl' }} zł
                <span *ngIf="payment.status === paymentStatus.AUTOMATIC_COMPLETED" class="secondary-text"
                >(autopłatność)</span
                >
              </div>
              <app-icon
                *ngIf="false"
                name="info_outlined"
                class="icon"
                [size]="17"
                matTooltip="{{ 'Prowizja za płatność: ' + (payment.commision | number: '1.2-2':'pl') + ' zł' }}"
              >
              </app-icon>
              <div *ngIf="payment.hasConfirmation">
                <app-icon
                  *ngIf="!payment.confirmationLoading; else loading"
                  name="save_alt"
                  [size]="16"
                  (click)="previewConfirmation(payment)"
                  class="icon"
                  matTooltip="Pobierz potwierdzenie płatności"
                ></app-icon>
              </div>
              <ng-template #loading>
                <mat-spinner [diameter]="20"></mat-spinner>
              </ng-template>
            </div>
          </div>
        </div>
        <div fxFlex="row" fxLayoutAlign="start start"  *ngIf="!!liability.bban">
          <div class="text-me">Nr rachunku bankowego:</div>
          <div  style=" max-width: 100%;">PL{{ liability.bban | mask: '00 0000 0000 0000 0000 0000 0000' }}</div>
        </div>
        <div fxFlex="row" fxLayoutAlign="start start" >
          <div class="text-me">Tytuł:</div>
          <div style=" max-width: 100%;">
            {{ liability?.title }}
          </div>
        </div>

        <div fxFlex="row" fxLayoutAlign="start start" >
          <div class="text-me">Notatka:</div>
          <div class="editable hidden" fxLayout="row" fxLayoutAlign="start center" (click)="editDescription()">
            <div class="mr-6">
              {{ liability?.description || 'Dodaj notatkę' }}
            </div>
            <app-icon name="mode_24" color="rgba(0,0,0,.47)" [size]="16"></app-icon>
          </div>
        </div>
      </div>
    </mat-card-content>

    <mat-card-actions fxLayout="column" fxLayoutGap="16px" fxLayoutAlign="center center">
      <app-new-loader-button
        *ngIf="showAddToCart"
        [loading]="addingToCart"
        [customType]="LoaderButtonType.RAISED"
        color="accent"
        class="big-button button-250"
        (buttonClick)="onInitPayment()"
      >
        Dodaj do koszyka
      </app-new-loader-button>

      <app-new-loader-button
        *ngIf="liability.inCart"
        [customType]="LoaderButtonType.RAISED"
        color="accent"
        class="big-button button-250"
        [routerLink]="['/liabilities/pay', liability.uncompletedPaymentId]"
        [queryParams]="{
          returnUrl: getReturnUrl()
        }">
        Przejdź do koszyka
      </app-new-loader-button>


      <button mat-button class="back-button button-250" (click)="goBack()">Wróć</button>
    </mat-card-actions>
  </mat-card>
</app-container>
<router-outlet></router-outlet>

<app-document-preview
  *ngIf="documentPreviewVisible && pdfUrl"
  [pdfUrl]="pdfUrl"
  [readonly]="true"
  (hidePreview)="documentPreviewVisible = false"
></app-document-preview>
